import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.NominationForm = class NominationForm extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-nomination-form';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
	}
};

$(function() {
	var CWNominationForm = new Snappy.Component.NominationForm();
	
	if($("input[type=checkbox].input-validation-error").length > 0 || $(".field-validation-error").length > 0)
	{
		$('html, body').animate({
			scrollTop: ($('.fa-nomination-form__form').offset().top - 80)
		}, 800);
	}
	
	function countWords(text) {
		text = text.replace(/(^\s*)|(\s*$)/gi, "");
		text = text.replace(/[ ]{2,}/gi, " ");
		text = text.replace(/\n /, "\n");
		return text.split(' ').length;
	}
	
	$("#ReasonForNomination").on("keydown", function (e) {
		var allowedKeys = [8, 46, 37, 38, 39, 40];
		var wordCount = countWords($("#ReasonForNomination").val());
		if (wordCount >= 310 && $.inArray(e.keyCode, allowedKeys) < 0) {
			return false;
		}
	});
	
	$(".fa-nomination-form__form button[type=submit]").on("click", function () {
		$("form.fa-nomination-form__form").submit();
		$(".fa-nomination-form__form button[type=submit]").attr("disabled", "disabled");
	});
	
	$(":not(input[type=checkbox]).input-validation-error")
		.removeClass("input-validation-error")
		.addClass("fa-input-field--error")
		.parent("div")
		.addClass("fa-input-field--error");
		
	$("input[type=checkbox].input-validation-error")
		.siblings("label")
		.css("color", "red");
	
	$(".field-validation-error").removeClass("field-validation-error")
		.addClass("fa-input-field__error-message");
});


// WEBPACK FOOTER //
// ./components/communityAwards/scripts/nominationForm.js